@if (hasMore()) {
  <div #scrollSentinel class="h-px" aria-hidden="true"></div>
  @if (loadingMore()) {
    <div class="p-md">
      <sb-loading-state />
    </div>
  } @else if (loadMoreFailed()) {
    <div class="flex flex-col items-center gap-sm p-md">
      <p class="reset-p text-base text-support">{{ 'Oops, something went wrong' | translate }}</p>
      <button sb-button color="secondary" (click)="onRetry()">{{ 'Retry' | translate }}</button>
    </div>
  }
}
